import React from 'react';

interface Department {
  id: string;
  name: string;
}

interface Office {
  id: string;
  name: string;
}

interface Selection {
  department: string;
  office: string;
}

interface DepartmentOfficeSelectorProps {
  departments: Department[];
  offices: Office[];
  selection: Selection;
  onDepartmentChange: (departmentName: string) => void;
  onOfficeChange: (officeName: string) => void;
  loading?: boolean;
}

const DepartmentOfficeSelector: React.FC<DepartmentOfficeSelectorProps> = ({
  departments,
  offices,
  selection,
  onDepartmentChange,
  onOfficeChange,
  loading = false,
}) => {
  return (
    <div className="mb-6 flex flex-col sm:flex-row gap-4">
      <div className="flex-1">
        <label className="block text-sm font-medium text-gray-700 mb-1">Departman</label>
        <select
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-400 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
          value={selection.department}
          onChange={e => onDepartmentChange(e.target.value)}
          disabled={loading}
        >
          {departments.map(dept => (
            <option key={dept.id} value={dept.name}>
              {dept.name}
            </option>
          ))}
        </select>
      </div>

      <div className="flex-1">
        <label className="block text-sm font-medium text-gray-700 mb-1">Büro</label>
        <select
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-400 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
          value={selection.office}
          onChange={e => onOfficeChange(e.target.value)}
          disabled={!selection.department || loading}
        >
          {offices.map(office => (
            <option key={office.id} value={office.name}>
              {office.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default DepartmentOfficeSelector;
